import { render, staticRenderFns } from "./T1TravelplanetCta.vue?vue&type=template&id=1218d370&scoped=true&"
import script from "./T1TravelplanetCta.vue?vue&type=script&lang=js&"
export * from "./T1TravelplanetCta.vue?vue&type=script&lang=js&"
import style0 from "./T1TravelplanetCta.vue?vue&type=style&index=0&id=1218d370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1218d370",
  null
  
)

export default component.exports